// Chat bubble strings (auto-merged by lib/i18n.ts).
export const en = {
  'chat.you': 'You',
  'chat.internal_note_suffix': ' · internal note',
  'chat.edit': 'Edit',
  'chat.delete': 'Delete',
  'chat.save': 'Save',
  'chat.cancel': 'Cancel',
  'chat.reply': 'Reply',
  'chat.load_earlier': 'Load earlier messages',
  'chat.loading_earlier': 'Loading…',
}

export const zhTW = {
  'chat.you': '您',
  'chat.internal_note_suffix': ' · 內部備註',
  'chat.edit': '編輯',
  'chat.delete': '刪除',
  'chat.save': '儲存',
  'chat.cancel': '取消',
  'chat.reply': '回覆',
  'chat.load_earlier': '載入較早的訊息',
  'chat.loading_earlier': '載入中…',
}
